import React from 'react'
import { Drawer } from 'antd'

import { DeliveryCostsPanel } from './DeliveryCostsPanel'

interface Props {
  open: boolean
  onClose: () => void
}

export const DeliveryCostsDrawer: React.FC<Props> = ({ open, onClose }) => {
  return (
    <Drawer
      title="Delivery Cost Calculation"
      placement="right"
      width={700}
      open={open}
      onClose={onClose}
    >
      {open && <DeliveryCostsPanel />}
    </Drawer>
  )
}
